import { render, staticRenderFns } from "./Abandon.vue?vue&type=template&id=0e52072a&scoped=true&"
import script from "./Abandon.vue?vue&type=script&lang=js&"
export * from "./Abandon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e52072a",
  null
  
)

export default component.exports